import * as M from "@discovery/prelude/lib/data/maybe";
import { AdobeEvents } from "./events";
import { isLogPage } from "@discovery/maestro-tourbus/lib/logs";
var LoginStatus;
(function (LoginStatus) {
    LoginStatus["Anonymous"] = "0";
    LoginStatus["LoggedIn"] = "1";
})(LoginStatus || (LoginStatus = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["NonPremiumUser"] = "avod";
    SubscriptionStatus["PremiumUser"] = "svod";
})(SubscriptionStatus || (SubscriptionStatus = {}));
let profileEvent;
const logToAdobeEvent = (log) => {
    if (isLogPage(log) && log.message === AdobeEvents.PAGE_LOADED) {
        return M.empty();
    }
    return M.empty();
};
const pushEvent = (event) => Array.isArray(window.digitalData) ? window.digitalData.push(event) : 0;
export const pushPageEvent = (name, type, brand, id, platform, subCategory, appType, language, time, userId, currentLocation, isLoggedIn, userPackage) => {
    const isGeoRestricted = currentLocation === "in" ? false : true;
    const isLoggedInUser = isLoggedIn.toString();
    const subscriptionUserID = userPackage !== "Free" ? userId : "";
    profileEvent = {
        loginStatus: isLoggedInUser === "true" ? LoginStatus.Anonymous : LoginStatus.LoggedIn,
        userID: userId,
        userType: userPackage === "Free"
            ? SubscriptionStatus.NonPremiumUser
            : SubscriptionStatus.PremiumUser,
        accountStatus: isLoggedInUser === "true" ? LoginStatus.Anonymous : LoginStatus.LoggedIn,
    };
    if (subscriptionUserID)
        profileEvent = Object.assign(Object.assign({}, profileEvent), { subscriptionUserID });
    const pageName = isGeoRestricted ? "Geo-Restricted" : name;
    pushEvent({
        event: AdobeEvents.PAGE_LOADED,
        page: {
            pageInfo: {
                pageName: pageName,
                pageType: isGeoRestricted ? "Geo-Restricted" : type,
                pageTitle: isGeoRestricted ? "Geo-Restricted" : type,
                brand: brand,
                pageUniqueID: id,
                platform: platform,
            },
            category: {
                subCategory: isGeoRestricted ? "Geo-Restricted" : subCategory,
                subCategory1: "n/a",
                subCategory2: "n/a",
            },
            environment: {
                app_type: appType,
                language: language,
                timestamp: time,
                version: "1.0.55",
            },
        },
        profile: subscriptionUserID
            ? Object.assign(Object.assign({}, profileEvent), { subscriptionUserID }) : profileEvent,
    });
};
export const pushFavoriteOrWatchListEvents = (eventName, eventLinkTitle, locationUrl, targetUrl) => {
    pushEvent({
        event: AdobeEvents.MODULE_LINK_TRACK,
        module: {
            name: eventName,
            linktitle: eventLinkTitle,
            locationurl: locationUrl,
            targeturl: targetUrl,
        },
        profile: profileEvent,
    });
};
export const pushFreeSearchEvent = (searchTerm, resultsCount, eventSearchRequery) => {
    pushEvent({
        event: AdobeEvents.FREE_SEARCH_EVENT,
        search: {
            searchTerm: searchTerm,
            searchResultsCount: resultsCount.toString(),
            internalSearchType: "freetext",
            eventSearchRequery: eventSearchRequery,
        },
        profile: profileEvent,
    });
};
export const pushSuggestedSearchEvent = (searchTerm, selectedSearchTerm, resultsCount) => {
    pushEvent({
        event: AdobeEvents.SUGGESTION_SEARCH_EVENT,
        search: {
            searchTerm: searchTerm,
            searchTermContextual: selectedSearchTerm,
            searchResultsCount: resultsCount.toString(),
            internalSearchType: "suggested search",
        },
        profile: profileEvent,
    });
};
export const pushNullSearchEvent = (searchTerm) => {
    pushEvent({
        event: AdobeEvents.FREE_SEARCH_EVENT,
        search: {
            searchTerm: searchTerm,
            noResultsSearchTerm: "true",
            internalSearchType: "freetext",
        },
        profile: profileEvent,
    });
};
export const pushModuleLinkTracking = (moduleUrl, position, title, moduleName, currentUrl, route) => {
    pushEvent({
        event: AdobeEvents.MODULE_LINK_TRACK,
        module: {
            name: moduleUrl,
            linkposition: position,
            linktext: title,
            linktitle: moduleName + "|" + title,
            locationurl: currentUrl,
            targeturl: "www.discoveryplus.in" + route,
        },
        profile: profileEvent,
    });
};
export const pushModuleBuyNowLinkTracking = (moduleUrl, position, title, moduleName, route) => {
    pushEvent({
        event: AdobeEvents.MODULE_LINK_TRACK,
        module: {
            name: moduleUrl,
            parentPosition: position,
            parentTitle: title,
            childTitle: moduleName,
            childPosition: 1,
            targetUrl: "www.discoveryplus.in" + route,
        },
        profile: profileEvent,
    });
};
export const pushHeaderMenuClickEvent = pushModuleLinkTracking;
export const pushSocialShareEvent = (name, platForm, url, actionType, isLoggedIn, userPackage, userId) => {
    const isLoggedInUser = isLoggedIn.toString();
    pushEvent({
        event: AdobeEvents.MODULE_LINK_TRACK,
        profile: {
            name: name,
            platformName: platForm,
            targetURL: url,
            smActionType: actionType,
            loginStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
            userID: userId,
            userType: userPackage === "Free"
                ? SubscriptionStatus.NonPremiumUser
                : SubscriptionStatus.PremiumUser,
            accountStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
        },
    });
};
export const pushLinkToAppEvent = (name, platForm, actionType, isLoggedIn, userPackage, userId) => {
    const isLoggedInUser = isLoggedIn.toString();
    pushEvent({
        event: AdobeEvents.MODULE_LINK_TRACK,
        profile: {
            name: name,
            platformName: platForm,
            smActionType: actionType,
            loginStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
            userID: userId,
            userType: userPackage === "Free"
                ? SubscriptionStatus.NonPremiumUser
                : SubscriptionStatus.PremiumUser,
            accountStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
        },
    });
};
export const pushErrorPageEvent = (error, isLoggedIn, userPackage, userId) => {
    const isLoggedInUser = isLoggedIn.toString();
    pushEvent({
        event: AdobeEvents.ERROR_TRACKING,
        error: {
            errorPages: error,
        },
        profile: {
            loginStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
            userID: userId,
            userType: userPackage === "Free"
                ? SubscriptionStatus.NonPremiumUser
                : SubscriptionStatus.PremiumUser,
            accountStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
        },
    });
};
export const pushAdImpressionEvents = (adId, adName, adPosition, adContentType, isLoggedIn, userPackage, userId) => {
    const isLoggedInUser = isLoggedIn.toString();
    pushEvent({
        event: AdobeEvents.AD_IMPRESSION,
        module: {
            ad_id: adId,
            ad_name: adName,
            ad_length: 0,
            ad_position: adPosition,
            ad_contentType: adContentType,
        },
        profile: {
            loginStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
            userID: userId,
            userType: userPackage === "Free"
                ? SubscriptionStatus.NonPremiumUser
                : SubscriptionStatus.PremiumUser,
            accountStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
        },
    });
};
export const subscribePricePlansEvent = (selectedPriceId, selectedPeriod, isLoggedIn, userPackage, userId) => {
    const isLoggedInUser = isLoggedIn.toString();
    pushEvent({
        event: AdobeEvents.SUBSCRIBE_PRICE_PLAN,
        profile: {
            loginStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
            userID: userId,
            userType: userPackage === "Free"
                ? SubscriptionStatus.NonPremiumUser
                : SubscriptionStatus.PremiumUser,
            accountStatus: isLoggedInUser === "true"
                ? LoginStatus.Anonymous
                : LoginStatus.LoggedIn,
            shoppingProducts: selectedPriceId,
            subscriptionID: "",
            subscriptionplan: selectedPeriod,
        },
    });
};
const initAdobe = (cache, adobeUrl) => {
    window.digitalData = window.digitalData || [];
    const log = new Promise((resolve, _) => {
        const dplusAdobeScript = {
            initialize: adobeUrl,
            tagType: "src",
        };
        cache._scriptTag("dplusAdobe", dplusAdobeScript);
        cache.dplusAdobe.onload = () => {
            const track = (event) => {
                try {
                    _satellite.track(event.event, event);
                }
                catch (e) {
                    // continue regardless of error
                }
            };
            resolve((event) => {
                // Push to global array
                pushEvent(event);
                // Use _satellite.track as a failsafe as push to global array is still new
                track(event);
            });
            try {
                _satellite.pageBottom();
            }
            catch (e) {
                console.info("error adobe", e);
                // continue regardless of error
            }
        };
    });
    return log;
};
export const createAdobeLogListener = (dplusAdobe, adobeUrl) => initAdobe(dplusAdobe, adobeUrl).then((log) => {
    return {
        log,
        transform: logToAdobeEvent,
    };
});

